var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.1523C4.5525 17.1523 0.9375 13.5373 0.9375 9.08984C0.9375 7.31984 1.5 5.63984 2.565 4.22984C2.7525 3.98234 3.105 3.93734 3.3525 4.12484C3.6 4.31234 3.6525 4.66484 3.465 4.91234C2.55 6.11984 2.0625 7.56734 2.0625 9.08984C2.0625 12.9148 5.175 16.0273 9 16.0273C12.825 16.0273 15.9375 12.9148 15.9375 9.08984C15.9375 5.26484 12.825 2.15234 9 2.15234C8.6925 2.15234 8.4375 1.89734 8.4375 1.58984C8.4375 1.28234 8.6925 1.02734 9 1.02734C13.4475 1.02734 17.0625 4.64234 17.0625 9.08984C17.0625 13.5373 13.4475 17.1523 9 17.1523Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.9023C5.7975 14.9023 3.1875 12.2923 3.1875 9.08984C3.1875 8.78234 3.4425 8.52734 3.75 8.52734C4.0575 8.52734 4.3125 8.78234 4.3125 9.08984C4.3125 11.6773 6.4125 13.7773 9 13.7773C11.5875 13.7773 13.6875 11.6773 13.6875 9.08984C13.6875 6.50234 11.5875 4.40234 9 4.40234C8.6925 4.40234 8.4375 4.14734 8.4375 3.83984C8.4375 3.53234 8.6925 3.27734 9 3.27734C12.2025 3.27734 14.8125 5.88734 14.8125 9.08984C14.8125 12.2923 12.2025 14.9023 9 14.9023Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.6523C8.6925 12.6523 8.4375 12.3973 8.4375 12.0898C8.4375 11.7823 8.6925 11.5273 9 11.5273C10.3425 11.5273 11.4375 10.4323 11.4375 9.08984C11.4375 7.74734 10.3425 6.65234 9 6.65234C8.6925 6.65234 8.4375 6.39734 8.4375 6.08984C8.4375 5.78234 8.6925 5.52734 9 5.52734C10.965 5.52734 12.5625 7.12484 12.5625 9.08984C12.5625 11.0548 10.965 12.6523 9 12.6523Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c9c2aab4b680c25dab8978f57b6d7af3.svg";
export { ForwardRef as ReactComponent };